export function deepCopy(obj: any): any {
  const isObject = (obj: any): any => obj && typeof obj === 'object'
  let copy: any
  if (null == obj || !isObject(obj)) return obj
  if (obj instanceof Array) {
    copy = []
    for (let i = 0, len = obj.length; i < len; i++) {
      copy[i] = deepCopy(obj[i])
    }
    return copy
  }
  if (isObject(obj)) {
    copy = {}
    for (const attr in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(attr)) copy[attr] = deepCopy(obj[attr])
    }
    return copy
  }
  throw new Error('Unable to copy')
}

export function mergeDeep(...objects: any): any {
  const isObject = (obj: any): boolean => obj && typeof obj === 'object'

  return objects.reduce((prev: any, obj: any) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key]
      const oVal = obj[key]

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = oVal
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal)
      } else if (oVal !== undefined) {
        prev[key] = oVal
      }
    })

    return prev
  }, {})
}

export function isGif(urlStr?: string | null): boolean {
  if (!urlStr) {
    return false
  }
  try {
    const url = new URL(urlStr)
    return url.pathname.toLowerCase().endsWith('.gif')
  } catch (e) {
    return false
  }
}

export function roundDecimal(num: number): number {
  return Math.round(num * 1000) / 1000
}
